// removed by extract-text-webpack-plugin
module.exports = {"profile-info":"profile-info","profile-picture":"profile-picture","profile-text":"profile-text"};


//////////////////
// WEBPACK FOOTER
// ./src/shared/PosterView/ProfileInfo.scss
// module id = cf2U
// module chunks = 0